export const runtimeConfig = {
  SHARE_BASE_URL: process.env.REACT_APP_SHARE_BASE_URL as string,
  BLOB_URL: process.env.REACT_APP_BLOB_URL as string,
};
